"use client";

import { useTranslations } from "next-intl";

export function PrintButton() {
	const t = useTranslations("research.dossier");

	return (
		<button
			type="button"
			onClick={() => window.print()}
			className="hover:bg-primary/90 inline-flex items-center rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition-colors"
		>
			{t("print")}
		</button>
	);
}
